<template>
    <div class="debug-page">
        <div style="display: flex">
            <direct-app-debug :app_raw_id="data.app_raw_id"></direct-app-debug>
            <app-debug v-if="data.app_id" :app_id="data.app_id"></app-debug>
            <driver-debug v-if="data.driver_id"  :driver_id="data.driver_id"></driver-debug>
        </div>

        <template v-if="data.app_id">
            <application-job-debug :app_id="data.app_id"></application-job-debug>
            <delivery-lead-debug :app_id="data.app_id"></delivery-lead-debug>

            <urlshortener-debug :app_id="data.app_id"></urlshortener-debug>
        </template>
    </div>
</template>

<script>
export default {
    props: [
        'data'
    ],
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style>
</style>